import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import kset from "../kset.mp4";

const Kset = () => {
  const navigate = useNavigate();
  const firstpage = () => {
    navigate("/page7", {
      state: { hexkey, hexuserInput, KeyValue, userInput },
    });
  };
  const second = () => {
    navigate("/page4", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
      },
    });
  };

  const location = useLocation();
  const userInput = location.state.userInput;
  const KeyValue = location.state.KeyValue;
  const hexuserInput = location.state.hexuserInput;
  const hexkey = location.state.hexkey;

  return (
    <>
    <div>
    <div className="mx-auto align-middle justify-cente text-center">
        <h1 className=" font-semibold text-3xl pb-5">Inside F function</h1>
        <p>
          We see how R0 and R1 goes into function g within the F function. 
          <br />R1 undergoes ROL which is a bitwise operation that shifts the bits of R1 to the left by 1 bit.
          <br />Click Next to see what happens in function g.
        </p>
      </div>
      
      <video autoPlay loop muted className="mx-auto align-middle justify-cente text-center max-h-96" >
      <source src={kset} type="video/mp4">
        </source>
      </video>

    </div>
    <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
            PREVIOUS
        </div>
    </div>
  </>
  );
};

export default Kset;
